export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 3.5a1 1 0 01.781.375L12.481 6H21l.102.005c.067.007.132.02.194.039l.015.005a.998.998 0 01.07.025l.037.018a.974.974 0 01.052.025l.021.013a1.008 1.008 0 01.138.093l.015.013A1.004 1.004 0 0122 7v11.5a1 1 0 01-1 1H3a1 1 0 01-1-1v-14a1 1 0 011-1h7zm-6 14h16V8h-8a1 1 0 01-.781-.375L9.519 5.5H4v12z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};